import React, { useContext } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { SearchResultPlan } from "../../@types";
import { SuppressionHandler } from "..";
import {
  useTranslate,
  getDisplayAnnualDrugDeductible,
  getLisToUse,
} from "../../helpers";
import { AppContext } from "../../app/store";
import { TooltipWithClose } from "../TooltipWithClose";

interface DeductibleProps {
  plan: SearchResultPlan;
}

const Deductible: React.FunctionComponent<DeductibleProps> = ({ plan }) => {
  const t = useTranslate();
  const {
    state: { futureLis, lis },
  } = useContext(AppContext);
  const { mctCurrentPlanYear: currentPlanYear } = useFlags();
  const lisToUse = getLisToUse({
    futureLis,
    lis,
    currentPlanYear,
    contractYear: plan.contract_year,
  });

  return (
    <div className="PlanCard__section" data-testid="deductible">
      <h3 className="PlanCard__section_heading">
        {t("plan_card.section_heading.deductible")}
      </h3>
      <div className="PlanCard__info_group">
        <div className="PlanCard__data ds-u-display--inline">
          <SuppressionHandler redactions={plan.redactions}>
            {getDisplayAnnualDrugDeductible({
              lisToUse,
              drugPlanDeductible: plan.drug_plan_deductible,
              contractYear: plan.contract_year,
            })}
          </SuppressionHandler>
        </div>
        <TooltipWithClose title={t("plan_card.tooltip.drug_deductible")}>
          {t("plan_terms.drug_deductible")}
        </TooltipWithClose>
      </div>
    </div>
  );
};

export default Deductible;
